import React from 'react';

export interface BravaLogoProps {
  width?: string | number;
  height?: string | number;
  className?: string;
  [key: string]: any;
}

const BravaLogo: React.FC<BravaLogoProps> = ({
  width = '120px',
  height = '28px',
  className = '',
  ...props
}) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 120 28"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <defs>
        <linearGradient
          id="bravaGradient"
          x1="0%"
          y1="100%"
          x2="100%"
          y2="0%"
        >
          <stop
            offset="0%"
            stopColor="#00B4D8"
          />
          <stop
            offset="100%"
            stopColor="#6C5CE7"
          />
        </linearGradient>
      </defs>

      <g
        id="BravaLogo"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        {/* Brava Icon - Heart/Pin/Checkmark shape based on description */}
        <g
          id="BravaIcon"
          transform="translate(2, 2)"
        >
          <path
            d="M8,20 C8,20 4,16 4,12 C4,9.5 5.5,8 8,8 C10.5,8 12,9.5 12,12 C12,16 8,20 8,20 Z M8,10 C6.5,10 5.5,11 5.5,12 C5.5,13 6.5,14 8,14 C9.5,14 10.5,13 10.5,12 C10.5,11 9.5,10 8,10 Z"
            fill="url(#bravaGradient)"
            fillRule="nonzero"
            transform="rotate(180 8 14)"
          />
          {/* Additional shape elements to match the heart/pin/checkmark description */}
          <path
            d="M8,2 C8,2 6,4 6,6 C6,7 6.5,7.5 8,7.5 C9.5,7.5 10,7 10,6 C10,4 8,2 8,2 Z"
            fill="url(#bravaGradient)"
            fillRule="nonzero"
          />
          <path
            d="M8,2 L12,6 L10,8 L8,6 L6,8 L4,6 Z"
            fill="url(#bravaGradient)"
            fillRule="nonzero"
          />
        </g>

        {/* BRAVA Text */}
        <g
          id="BravaText"
          transform="translate(28, 0)"
        >
          <text
            x="0"
            y="20"
            fontFamily="Arial, sans-serif"
            fontSize="16"
            fontWeight="bold"
            fill="#1E3A8A"
            letterSpacing="1px"
          >
            BRAVA
          </text>
        </g>
      </g>
    </svg>
  );
};

export default BravaLogo;
